<template>
  <div>
    <TitlePage :title="$t('report')"></TitlePage>
    <v-container fluid>
      <div class="dashboard-page">
        <v-row>
          <v-col md="10" xs="12">
            <v-chip color="primary" label small text-color="white">Promo Super Admin</v-chip>
          </v-col>
          <v-col cols="12" md="12">
            <v-card elevation="2">
              <v-card>
                <v-card-title>
                  <v-text-field v-model="search" append-icon="mdi-magnify" label="Filtra nella tabella" single-line hide-details dense/>
                </v-card-title>
                <template>
                  <div class="text-left">
                    <v-chip
                        class="ma-2"
                        filter-icon="mdi-magnify"
                        @click="filter = 'all'"
                    >
                      <v-icon left v-if="filter === 'all'">
                        mdi-check
                      </v-icon>
                      Tutte
                    </v-chip>

                    <v-chip
                        class="ma-2"
                        color="primary"
                        @click="filter = 'in_progress'"
                    >
                      <v-icon left v-if="filter === 'in_progress'">
                        mdi-check
                      </v-icon>
                      In vendita
                    </v-chip>

                    <v-chip
                        class="ma-2"
                        color="green"
                        text-color="white"
                        @click="filter = 'sold'"
                    >
                      <v-icon left v-if="filter === 'sold'">
                        mdi-check
                      </v-icon>
                      Venduta
                    </v-chip>

                    <v-chip
                        class="ma-2"
                        color="red"
                        text-color="white"
                        @click="filter = 'not_sold'"
                    >
                      <v-icon left v-if="filter === 'not_sold'">
                        mdi-check
                      </v-icon>
                      Invenduta
                    </v-chip>

                    <v-chip
                        class="ma-2"
                        color="secondary lighten-2"
                        text-color="white"
                        @click="filter = 'not_enabled'"
                    >
                      <v-icon left v-if="filter === 'not_enabled'">
                        mdi-check
                      </v-icon>
                      Non abilitata
                    </v-chip>
                  </div>
                </template>
                <v-data-table :headers="headers" :items="filteredList" :search="search" :items-per-page="-1" :sort-by="['center_name', 'field_name']" :sort-desc="[false, false]">
                  <template v-slot:item.center_name="{ item }">
                    <v-badge inline :color="item.center_promo_sa_global_active ? 'green':'grey'" dot></v-badge>
                    <span class="font-weight-bold">{{item.center_name}}</span>
                  </template>
                  <template v-slot:item.center_bookings="{ item }">
                    <v-icon @click="goToBookings(item.center_id, null)">mdi-calendar</v-icon>
                  </template>
                  <template v-slot:item.field_name="{ item }">
                    <v-badge inline :color="item.field_promo_sa_global_active ? 'green':'grey'" dot></v-badge>
                    <span>{{item.field_name}}</span>
                  </template>
                  <template v-slot:item.field_bookings="{ item }">
                    <v-icon @click="goToBookings(item.center_id, item.field_id)">mdi-calendar</v-icon>
                  </template>
                  <template v-slot:item.promo_sa_status="{ item }">
                    <v-chip v-if="item.promo_sa_status === 'enabled' && item.suspended" color="yellow" small label>
                      STAND BY
                    </v-chip>
                    <v-chip v-else-if="item.promo_sa_status === 'enabled'" color="green" dark small label>
                      ATTIVA
                    </v-chip>
                    <v-chip v-else-if="item.promo_sa_status === 'not_enabled'" color="grey" dark small label>
                      NON ABILITATA
                    </v-chip>
                  </template>
                  <template v-slot:item.promo_sa_start_date="{ item }">
                    <template v-if="(item.promo_sa_status === 'enabled' || item.promo_sa_status === 'paused') && item.promo_sa_start_date">
                      {{item.promo_sa_start_date}}
                    </template>
                    <template v-else>
                      N.D.
                    </template>
                  </template>
                  <template v-slot:item.promo_sa_end_date="{ item }">
                    <template v-if="(item.promo_sa_status === 'enabled' || item.promo_sa_status === 'paused') && item.promo_sa_end_date !== 'n.d.'">
                      {{item.promo_sa_end_date}}
                    </template>
                    <template v-else>
                      N.D.
                    </template>
                  </template>
                  <template v-slot:item.suspended="{ item }">
                    <template v-if="item.promo_sa_start_date === 'n.d.'" >
                      <v-chip color="orange" small label dark>
                        ERRORE
                      </v-chip>
                    </template>
                    <template v-else-if="item.suspended  && !item.lastBooking" >
                      <v-chip color="red" small label dark>
                        INVENDUTA
                      </v-chip>
                    </template>
                    <template v-else-if="item.suspended && item.lastBooking">
                      <v-chip color="green" dark small label >
                        VENDUTA
                      </v-chip>
                    </template>
                    <template v-else-if="item.promo_sa_status === 'enabled' && !item.suspended">
                      <v-chip color="primary" dark small label >
                        IN VENDITA
                      </v-chip>
                    </template>
                  </template>

                  <template v-slot:item.lastBooking="{ item }">
                    <v-chip v-if="item.lastBooking" color="green" dark small label outlined>
                      {{ new Date(item.lastBooking).toLocaleString() }}
                    </v-chip>
                  </template>

                  <template v-slot:item.pricePromoSa="{ item }">
                    <v-chip v-if="item.lastBookingPrice" color="green" dark small label>
                      {{ item.lastBookingPrice }}
                    </v-chip>
                    <v-chip v-else-if="item.promo_sa_global_price" color="yellow" dark small label text-color="black">
                      {{ item.promo_sa_global_price }}
                    </v-chip>
                  </template>

                  <template v-slot:item.date_next_promo_sa="{ item }">
                    <template v-if="item.date_next_promo_sa">
                      <v-chip  color="primary" dark small label outlined>
                        {{ new Date(item.date_next_promo_sa).toLocaleString() }}
                      </v-chip>
                    </template>
                  </template>

                  <template v-slot:item.date_next_promo_sa_count="{ item }">
                    <template v-if="item.date_next_promo_sa">
                      <v-chip color="orange" dark small label outlined>
                        <strong>{{getRemainingTime(item.date_next_promo_sa)}}</strong>
                      </v-chip>
                    </template>
                  </template>

                </v-data-table>
              </v-card>
            </v-card>
          </v-col>
        </v-row>
        <v-divider class="ma-5"></v-divider>
      </div>
    </v-container>
  </div>
</template>

<script>
import TitlePage from "../utils/TitlePage";
import CenterAutocomplete from "@/components/admin/CenterAutocomplete";
import {mapActions, mapMutations} from "vuex";

export default {
  name: "ReportPromoSA",
  components: {TitlePage,CenterAutocomplete},
  data() {
    return {
      list:[],
      search: '',
      headers: [
        { text: 'Centro Sportivo', align: 'start', value: 'center_name', class:'header-table'},
        { text: '', align: 'start', value: 'center_bookings', class:'header-table', sortable: false},
        { text: 'Campo', value: 'field_name', class:'header-table'},
        { text: '', align: 'start', value: 'field_bookings', class:'header-table', sortable: false},
        { text: 'Attiva', value: 'promo_sa_status', class:'header-table', sortable: false},
        { text: 'Data Inizio', value: 'promo_sa_start_date', class:'header-table', sortable: false},
        { text: 'Data Fine', value: 'promo_sa_end_date', class:'header-table', sortable: false},
        { text: 'GG Invenduta', align: 'center', value: 'days_unsold', class:'header-table', sortable: false},
        { text: 'Stato', value: 'suspended', class:'header-table', sortable: false},
        { text: 'Prezzo', align: 'center', value: 'pricePromoSa', class:'header-table', sortable: false},
        { text: 'Ultima Prenotazione', align: 'center', value: 'lastBooking',class:'header-table', sortable: false},
        { text: 'Prox. Abilitazione', align: 'center', value: 'date_next_promo_sa',class:'header-table', sortable: false},
        { text: '', align: 'center', value: 'date_next_promo_sa_count',class:'header-table', sortable: false},
      ],
      interval: null,
      filter: 'all'
    };
  },
  mounted() {
    this.interval = window.setInterval(() => {
      this.$forceUpdate();
    },1000);
  },
  beforeDestroy() {
    window.clearInterval(this.interval);
  },
  computed: {
    filteredList() {
      if (this.filter === 'all') return this.list;

      return this.list.filter(item => {
        switch (this.filter) {
          case 'in_progress':
            return item.promo_sa_status === 'enabled' && !item.suspended;
          case 'sold':
            return item.suspended && !!item.lastBooking;
          case 'not_sold':
            return item.suspended && !item.lastBooking;
          case 'not_enabled':
            return item.promo_sa_status === 'not_enabled';
          default:
            return true;
        }
      });
    }
  },
  async created() {
    this.setLoading(true);
    await this.makeSearch()
    this.setLoading(false);
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),

    ...mapActions({
      'getPromoSuperAdminStats': 'stats/getPromoSuperAdminStats',
    }),


    goToBookings(center_id, field_id){
      if(center_id && field_id){
        this.$router.push(`bookings?center_id=${center_id}&field_id=${field_id}&promo_sa_global=true`);
      }else if(center_id){
        this.$router.push(`bookings?center_id=${center_id}&promo_sa_global=true`);
      }
    },

    goToHandler(section) {
      switch (section) {
        case "centers":
          this.$router.push('/centers/');
          break
        case "fields":
          this.$router.push('/fields/');
          break
      }
    },

    async makeSearch(){

      this.setLoading(true);
      let results = await this.getPromoSuperAdminStats({});

      results.result.map((center) => {

        center.center_fields.map((field) => {

          let obj = {
            center_name: center.center_name,
            center_id: center.center_id,
            center_promo_sa_global_active: center.promo_sa_global.active,
            field_name: field.name,
            field_id: field._id,
            field_promo_sa_global_active: field.promo_sa_global.active,
          }

          if(!center.promo_sa_global.active || !field.promo_sa_global.active){
            obj.promo_sa_status = 'not_enabled'
          }else if(center.promo_sa_global.active && field.promo_sa_global.active){
            obj.promo_sa_status = 'enabled'
            obj.promo_sa_start_date = (field.promo_sa_global.start_time) ? new Date(field.promo_sa_global.start_time).toLocaleDateString() : 'n.d.'
            obj.promo_sa_end_date = (field.promo_sa_global.no_end) ? '∞' : new Date(field.promo_sa_global.end_time).toLocaleDateString()
            obj.suspended = field.suspended
            obj.date_next_promo_sa = field.date_next_promo_sa
            obj.lastBooking = field.lastBooking
            obj.lastBookingPrice = (field.lastBookingPrice) ? field.lastBookingPrice.toFixed(2)+ ' €' : null
            obj.promo_sa_global_price = (field.promo_sa_global_price) ? field.promo_sa_global_price.toFixed(2)+ ' €*' : null
            obj.days_unsold = field.days_unsold.toFixed(2)+' GG'
            // obj.date_next_promo_sa_days = field.date_next_promo_sa_days.toFixed(2)+' GG'
          }

          this.list.push(obj)

        })

      })

      this.setLoading(false);
    },

    getRemainingTime(date){
        let date_future = new Date(date);
        let date_now = new Date();

        let seconds = Math.floor((date_future - (date_now))/1000);
        let minutes = Math.floor(seconds/60);
        let hours = Math.floor(minutes/60);
        let days = Math.floor(hours/24);

        hours = hours-(days*24);
        minutes = minutes-(days*24*60)-(hours*60);
        seconds = seconds-(days*24*60*60)-(hours*60*60)-(minutes*60);

        return `- ${days}g ${hours}h ${minutes}m ${seconds}s`
    }
  },


}
</script>

<style>
.grey-row{
  background-color: #f1f1f1 !important
}
</style>